const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "16%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "11%"
  },
  {
    key: "avgCurrent",
    zh: "平均电流(A)",
    en: "Average Current(A)",
    width: "13%",
    tooltip: true
  },
  {
    key: "fanTemperature",
    zh: "设定温度(℃)",
    en: "Fan Temperature(℃)",
    width: "12%",
    tooltip: true
  },
  {
    key: "avgTemperature",
    zh: "平均温度(℃)",
    en: "Average Temperature(℃)",
    width: "13%",
    tooltip: true
  },
  {
    key: "ratedTemperature",
    zh: "极限温度(℃)",
    en: "Rated Temperature(℃)",
    width: "11%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "高温率",
    en: "Percentage",
    width: "10%"
  }
]

export default columns